export default __webpack_public_path__ + "static/media/congratsArrow.17084265.svg";